export default class Variation
{
  constructor(name, color, size, characterId) 
  {
    this.name = name;
    this.color = color;
    this.size = size;
    this.characterId = characterId;
  }    

  isValid()
  {
    return this.name && this.color && this.size && this.characterId;
  }
}